module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('em', [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I have derived considerable benefit from conversations with Dr Lorn Macintyre, Alastair McIntosh, Iain Thornber, Lord Bruce Weir, Canon John Paul MacKinnon, Father William Fraser and Father Roddy Johnston. I am grateful to Iain Thomson for permission to quote from "), _c('em', [_vm._v("Isolation Shepherd")]), _vm._v(", to Dr Mickey Vallee for permission to quote from the 1955 article by his grandfather, Professor Frank Vallee, on burial practices in Barra, and to John Bell and the Wild Goose Resource Group for permission to quote ‘The Last Journey’. Hugh Andrew and Andrew Simmons of Birlinn have been consistently supportive and helpful. Helen Bleck has been a meticulous copy editor.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f7eb17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgements.vue
// module id = 69
// module chunks = 0